<template>
  <g>
    <path
      d="M15.5 11.0002C16.3284 11.0002 17 10.3287 17 9.50024C17 8.67182 16.3284 8.00024 15.5 8.00024C14.6716 8.00024 14 8.67182 14 9.50024C14 10.3287 14.6716 11.0002 15.5 11.0002Z"
    />
    <path
      d="M8.5 11.0002C9.32843 11.0002 10 10.3287 10 9.50024C10 8.67182 9.32843 8.00024 8.5 8.00024C7.67157 8.00024 7 8.67182 7 9.50024C7 10.3287 7.67157 11.0002 8.5 11.0002Z"
    />
    <path
      d="M11.99 2.00024C6.47 2.00024 2 6.48024 2 12.0002C2 17.5202 6.47 22.0002 11.99 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 11.99 2.00024ZM12 20.0002C7.58 20.0002 4 16.4202 4 12.0002C4 7.58024 7.58 4.00024 12 4.00024C16.42 4.00024 20 7.58024 20 12.0002C20 16.4202 16.42 20.0002 12 20.0002ZM12 14.0002C10.1 14.0002 8.37 14.9702 7.35 16.5802C7.13 16.9302 7.24 17.3902 7.59 17.6102C7.94 17.8302 8.4 17.7202 8.62 17.3702C9.36 16.1902 10.62 15.4902 12 15.4902C13.38 15.4902 14.64 16.1902 15.38 17.3702C15.52 17.6002 15.77 17.7202 16.02 17.7202C16.16 17.7202 16.29 17.6802 16.42 17.6102C16.77 17.3902 16.88 16.9302 16.66 16.5802C15.63 14.9602 13.9 14.0002 12 14.0002Z"
    />
  </g>
</template>
